import Uuid from "../../../../support/Uuid";

class ComprobanteAerolineasInputPipe {

  getName() {
    return 'Aerolineas';
  }

  apply(data, comprobante) {

    const { Complemento } = data;

    if (!Complemento || !Complemento.Aerolineas) {
      return data;
    }

    let { Aerolineas } = Complemento;

    if (!!Aerolineas.OtrosCargos) {
      data.Complemento.Aerolineas.OtrosCargos = {
        ...Aerolineas.OtrosCargos,
        Cargo: Aerolineas.OtrosCargos.Cargo.map((value) => {
          return {
            id: Uuid.v4(),
            ...value
          }
        })
      }
    }

    return data;
  }
}

export default ComprobanteAerolineasInputPipe;